export default class Accordion {
  constructor(element) {
    this.element = element;
    this.containers = this.element.querySelectorAll('.js-accordion');
    this.options = {
      openDefault: false,
      notClosing: false,
    };
    this.numberOpen = 0;

    this.init();
  }

  init() {
    this.setOptions();

    for (let i = 0; i < this.containers.length; i++) {
      const container = this.containers[i];
      const title = container.querySelector(".accordion-title");
      if (!title) {
        console.warn("Titre manquant dans un accordéon :", container);
        continue; 
      }

      //container.querySelector(".accordion-title").addEventListener('click', this.toggleAccordion.bind(this));

      let isMouseDown = false;

      title.addEventListener('mousedown', () => {
        isMouseDown = true;
      });

      title.addEventListener('focus', (e) => {
        if (!isMouseDown) {
          const parent = e.currentTarget.parentElement;
          if (!parent.classList.contains('is-active')) {
            this.toggleAccordion(e);
          }
        }
        isMouseDown = false;
      });

      title.addEventListener('click', this.toggleAccordion.bind(this));

      if ('open' in container.dataset) {
        container.classList.add('is-active');
        this.numberOpen++;
      }
    }
  }

  toggleAccordion(element) {
    const target = element.currentTarget;
    const parent = target.parentElement;
    const isActive = parent.classList.contains('is-active');

    if(isActive){
        parent.classList.remove("is-active");
        return;
    }

    if(!this.options.notClosing){
        for (let i = 0; i < this.containers.length; i++) {
            const container = this.containers[i];
            if(this.numberOpen <= 1){
                container.classList.remove("is-active");
            }
        }
    }

    parent.classList.add("is-active");
  }

  setOptions() {
    if ('open' in this.element.dataset) {
      this.options.openDefault = true;
    }

    if ('notClosing' in this.element.dataset) {
        this.options.notClosing = true;
    }
  }
}
